import restClient from "../restClient";

export const getNotifications = async ({
  isRead = false,
  page = 1,
  pageSize = 10,
} = {}) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        is_read: isRead,
        page,
        pageSize,
      },
    };
    const response = await restClient.get(`notifications`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
